import * as api from '../services/autoDialOps';

export const AUTODIAL_OPS_LOAD          = 'AUTODIAL_OPS_LOAD';
export const AUTODIAL_OPS_LOADING       = 'AUTODIAL_OPS_LOADING';
export const AUTODIAL_OPS_ERROR         = 'AUTODIAL_OPS_ERROR';
export const AUTODIAL_OPS_SET_AGENT     = 'AUTODIAL_OPS_SET_AGENT';
export const AUTODIAL_OPS_TOGGLE_LIVE   = 'AUTODIAL_OPS_TOGGLE_LIVE';

/**
 * The dashboard's insurer comes from `state.user.insurer` (set at login).
 * Components don't need to know the insurer — the thunks read it from store.
 */
const insurerFromState = (getState) => {
  const u = getState().user || {};
  return u.insurer || 'max';
};

export const loadOpsData = (agentType) => async (dispatch, getState) => {
  const state   = getState();
  const insurer = insurerFromState(getState);
  const type    = agentType || state.autoDialOps.agentType;

  dispatch({ type: AUTODIAL_OPS_LOADING });
  try {
    const data = await api.getMisV2(insurer, type);
    dispatch({
      type: AUTODIAL_OPS_LOAD,
      payload: { ...data, agentType: type, insurer },
    });
  } catch (err) {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message;
    dispatch({ type: AUTODIAL_OPS_ERROR, payload: msg });
  }
};

export const setAgentType = (agentType) => (dispatch) => {
  dispatch({ type: AUTODIAL_OPS_SET_AGENT, payload: agentType });
  dispatch(loadOpsData(agentType));
};

export const toggleLive = () => ({ type: AUTODIAL_OPS_TOGGLE_LIVE });

export const triggerManualRedial = (applicationNos, agentType) => async (dispatch, getState) => {
  const insurer = insurerFromState(getState);
  try {
    const result = await api.manualRedial(insurer, applicationNos, agentType);
    dispatch(loadOpsData(agentType));
    return result;
  } catch (err) {
    dispatch({ type: AUTODIAL_OPS_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};
